import React, { memo, useMemo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, errors, currentOrg,
}) {
  const payerFilter = useMemo(
    () => ({ org: currentOrg }),
    [currentOrg],
  );
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.DateInput
          value={row.datefrom}
          onChange={(e, v) => actions.onChange(e, row.id, { datefrom: v })}
          readOnly={fields.datefrom.read_only || readOnly}
          errors={errors && errors.datefrom}
        />
      </TableCell>
      <TableCell>
        <TableControls.ItemPicker
          value={row.payer}
          onChange={(e, v) => actions.onChange(e, row.id, { payer: v })}
          readOnly={fields.payer.read_only || readOnly || !currentOrg}
          errors={errors && errors.payer}
          backend={fields.payer.resource}
          filter={payerFilter}
        />
      </TableCell>
      <TableCell>
        <TableControls.NumerInput
          value={row.proportion}
          onChange={(e, v) => actions.onChange(e, row.id, { proportion: v })}
          readOnly={fields.proportion.read_only || readOnly}
          errors={errors && errors.proportion}
          precision={2}
        />
      </TableCell>
      <TableCell>
        <TableControls.Selector
          value={row.dimension}
          precision={2}
          onChange={(e, v) => actions.onChange(e, row.id, { dimension: v })}
          readOnly={fields.dimension.read_only || readOnly}
          values={fields.dimension.choices}
          errors={errors && errors.dimension}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number,
    datefrom: PropTypes.string,
    dateto: PropTypes.string,
    payer: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
    proportion: PropTypes.number,
    dimension: PropTypes.string,
  }).isRequired,
  fields: PropTypes.shape({
    datefrom: PropTypes.shape({ read_only: PropTypes.bool }),
    dateto: PropTypes.shape({ read_only: PropTypes.bool }),
    payer: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
    proportion: PropTypes.shape({ read_only: PropTypes.bool }),
    dimension: PropTypes.shape({
      read_only: PropTypes.bool,
      choices: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        display_name: PropTypes.string,
      })),
    }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  errors: PropTypes.shape({
    datefrom: PropTypes.arrayOf(PropTypes.string),
    payer: PropTypes.arrayOf(PropTypes.string),
    proportion: PropTypes.arrayOf(PropTypes.string),
    dimension: PropTypes.arrayOf(PropTypes.string),
  }),
  currentOrg: PropTypes.number,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  errors: null,
  currentOrg: null,
};

export default memo(Row);
